import { render, staticRenderFns } from "./Purchase.vue?vue&type=template&id=8b32ac94"
import script from "./Purchase.vue?vue&type=script&lang=js"
export * from "./Purchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports